// extracted by mini-css-extract-plugin
export default {"item":"MenuGroup_item__79EML","selected":"MenuGroup_selected__IaxMj"};